export const USER_ENTITIES_STATE_KEY = 'user-entities';
